import { allTrackers } from "app/services/track/track";
import LocationService from "pro-features/components/Modals/src/UnlockModal/LocationService";

export const trackEvents = (action: string, eventName: string, isCCUser: boolean) => {
    allTrackers.dispatchTrackEvent(
        "Pro Hooks 2.0",
        action,
        `${eventName}/${isCCUser ? "trialEndedCCflow" : "trialEnded"}/${LocationService.getCurrentLocationTracking()}`,
    );
};
